/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import radio from '@salesforce/retail-react-app/app/theme/components/base/radio'

export default {
    ...radio,
    baseStyle: {
        ...radio.baseStyle,
        control: {
            backgroundColor: 'gray.200',
            borderColor: 'gray.600',
            border: '1px solid',
            transition: '0.3s border-color ease',
            width: '18px',
            marginTop: '0 !important',
            height: '18px',
            _hover: {
                borderColor: 'gray.650'
            },
            _checked: {
                width: '18px',
                height: '18px',
                background: 'gray.200 !important',
                borderColor: 'gray.600',
                backgroundColor: 'gray.200',
                _hover: {
                    borderColor: 'gray.650'
                },
                '&::before': {
                    background: 'purple.100',
                    width: '75%',
                    height: '75%'
                }
            },
            _indeterminate: {}
        }
    },
    sizes: {
        md: {
            container: {alignItems: 'flex-start'},
            control: {marginLeft: '10px'},
            label: {marginLeft: 3}
        }
    }
}
